import * as angular from 'angular';
import * as _ from 'underscore';
import { NotificationService } from '../../../../../app.common/modules/common/services/notification.service';
import { PlaceListShortModel, StoreFindFilter } from '../../../core';
import { NfcRetailerStickersService } from '../../nfc-retailer-stickers.service';

export interface ILocationModel  extends PlaceListShortModel {
	IsSelected?: boolean;
}

class SelectLocations implements ng.IController {
	static $inject = ['$translate', 'nfcRetailerStickersService', 'notificationService'];
	modalInstance: ng.ui.bootstrap.IModalInstanceService = <any>this;

	public model = {
		addButtonText: 'Add' as string,
		locations: [] as ILocationModel[],
		searchTerm: null as string,
		waiting: true as boolean,
		isAllSelected: false as boolean,
        noLocationMessage: this.$translate.instant('nfc_select_location_empty_list_message') as string
	};

	total: number = 0;
	canSelectAll: boolean = true;

	public resolve: {
		options: {
			selectedLocations: PlaceListShortModel[],
			isAllSelected: boolean,
            fullName: boolean,
		}};

	constructor(
		protected $translate: angular.translate.ITranslateService,
		public nfcRetailerStickersService: NfcRetailerStickersService,
		private notificationService: NotificationService
	) {
	}

	public $onInit(): void {
		this.loadLocations()
			.then(() => this.canSelectAll = this.total > 0);
	}

    public searchKeyPressed($event: KeyboardEvent) {
        if ($event.which === 13 && !this.model.waiting) {
            this.search(this.model.searchTerm);
        }
	}

	public confirm() {
		let selectionResult = {
			status: 'ok',
			isAllSelected: false,
			selectedLocations: <PlaceListShortModel[]>[]
		};

		if (this.model.isAllSelected) {
		    selectionResult.selectedLocations = this.model.locations;
			selectionResult.isAllSelected = true;
			this.modalInstance.close( { $value: selectionResult});
			return;
		}

		selectionResult.selectedLocations = this.getSelectedLocations();
		this.modalInstance.close( { $value: selectionResult});
	}

	public getSelectedLocations = () : ILocationModel[]  => this.model.locations.filter((location) => location.IsSelected);

	private search(text: string) {
		this.total = 0;
		this.model.locations = [];
		this.model.searchTerm = text;
		this.loadLocations();
	}

	private resetSearch() {
        this.model.searchTerm = '';
        this.search(this.model.searchTerm);
    }

	private loadLocations() {
		const selectedLocations = this.resolve.options.selectedLocations;

        if ( this.total && this.model.locations.length === this.total) {
            return;
		}

		let filter : StoreFindFilter = {
		    SearchTerm: this.model.searchTerm,
            Limit: 20,
            SearchAfterName: this.model.locations.length ? _.last(this.model.locations).Name : null
		};

		this.model.waiting = true;
		this.notificationService.showWaitingMessage();

		return this.nfcRetailerStickersService.getLocations(filter)
			.then(response => {
                this.total = response.Total;
				let locations: ILocationModel[] = response.Items;
				locations.forEach((location) => {
					const foundLocation = _.find(selectedLocations, {ID: location.ID});
					location.IsSelected = !!foundLocation;
				});
				Array.prototype.push.apply(this.model.locations, locations);
				this.model.waiting = false;
				this.model.isAllSelected = this.resolve.options.isAllSelected;

				if (this.model.locations.length) {
					return;
				}

				            this.model.noLocationMessage = this.model.searchTerm && this.model.searchTerm.length
					? this.$translate.instant('location_was_not_found', {search: this.model.searchTerm})
					: this.$translate.instant('nfc_select_location_empty_list_message');
			})
			.catch((e) => this.notificationService.showErrorMessage(e))
			.finally(() => this.notificationService.clearAll());
	}

	private setAddButtonText() {
		var addbtn = this.$translate.instant('button_add');

		if (this.model.isAllSelected) {
			this.model.addButtonText = addbtn + ' (' + this.$translate.instant('all') + ')';
		} else {
			let selectedLocationCount = this.getSelectedLocations().length;
			this.model.addButtonText = selectedLocationCount > 0 ? addbtn + ' (' + selectedLocationCount + ')' : addbtn;
		}
	}

	private dismiss = () => this.modalInstance.close({$value: {status: 'close'}});
}

angular.module('naut').component('selectLocations', {
	template: require('./select-locations.component.html'),
	controller: SelectLocations,
	controllerAs: 'ctrl',
	bindings: {
		resolve: '<',
		close: '&',
		dismiss: '&'
	}
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/nfc-stickers/shared/select-locations/select-locations.component.ts